import React from 'react';
// Constants
import { ContactEmailAddress } from '../../utils/Constants';
// Images
import SecondImage from '../../assets/images/main/mistress-diva-pro-dominatrix-and-femdom-in-red-blowing-pin-wheel-holding-whip-sexy.jpeg';
import ThirdImage from '../../assets/images/main/mistress-diva-pro-dominatrix-and-femdom-leaning-sexy.jpg';

function ContactPageMainContainer() {
  return (
    <main role='main' className='grid gap-8 pt-6 pb-12 w-full'>
      <div className='grid px-6 sm:px-8 md:px-12 lg:container lg:mx-auto text-white'>
        <h1 className='text-4xl font-bold font-hello-paris-light text-center mb-8'>
          Apply to Serve Mistress Diva…
        </h1>

        <div className='grid gap-4 max-w-3xl mx-auto text-lg leading-relaxed font-argesta'>
          <p className='pt-2'>Keep the following in mind when contacting Me…</p>

          <ul className='list-disc pl-6 space-y-4'>
            <li>
              <strong>Initial contact is by email only.</strong>
            </li>
            <li>
              <strong>
                My sessions start at 2 hours minimum. One hour sessions may be
                considered with additional tribute.
              </strong>
            </li>
            <li>
              <strong>
                Rude or disrespectful replies, including text speak or
                one-liners, will not be answered.
              </strong>
            </li>
            <li>
              <strong>
                Make sure you are ready and serious when booking in with Me.
              </strong>
            </li>
            <li>
              <strong>
                Your privacy is of paramount importance, absolute discretion is
                assured and guaranteed.
              </strong>
            </li>
            <li>
              <strong>Unsolicited calls and texts will not be answered.</strong>
            </li>
            <li>
              <strong>My fees are non-negotiable. Do not ask.</strong>
            </li>
            <li>
              <strong>
                I am meticulous with My personal hygiene, the cleanliness of My
                Dungeon Space and My equipment. Intending slaves will adhere to
                the same rules… (no smoking at least 2 hours before your booking
                with Me and always arrive with a fresh clean breath){' '}
              </strong>
            </li>
          </ul>

          <div className='text-center mt-10'>
            <span className='font-bold block'>EMAIL</span>
            <a
              href={`mailto:${ContactEmailAddress}`}
              className='hover:underline break-all'
            >
              {ContactEmailAddress}
            </a>
          </div>

          <article className='grid text-white text-xs md:text-lg lg:text-xl leading-relaxed gap-y-4 lg:gap-y-8 text-center py-4'>
            <div className='mx-auto w-24 h-1 bg-colour1'></div>
            <div className='font-argesta grid gap-y-6 text-xl'>
              <p>
                <strong className=''>
                  As an International, Professional Dominatrix and Mistress who
                  travels extensively, I seek private and discrete locations to
                  conduct My sessions and appointments.
                </strong>
              </p>
              <p>
                <strong>
                  Available in Perth, Australia. I require the following:
                </strong>
              </p>
              <p>
                <strong>
                  Rental apartments or Airbnb’s that offer a high level of
                  privacy, ensuring My stay remains discreet.
                </strong>
              </p>
              <p>
                <strong>
                  {' '}
                  There may be an opportunity for you to serve Me , however, it
                  will be up to Me to decide— and strictly at My discretion.
                </strong>
              </p>
              <p>
                <strong>Email Me for further details.</strong>
              </p>
              <p className='mt-8 text-center text-xl hidden lg:block'>
                "By submitting to My desires you will find exhilarating
                freedom"...
              </p>
            </div>
          </article>
          <div className='mx-auto grid lg:grid-cols-2 gap-y-4 max-w-2xl lg:hidden'>
            <img src={SecondImage} alt='Main Mistress' className='w-full' />
            <img src={ThirdImage} alt='Main Mistress' />
            <p className='mt-8 text-center text-xl lg:hidden'>
              "By submitting to My desires you will find exhilarating
              freedom"...
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default ContactPageMainContainer;
